import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider.js";
import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";
import { waitForLoyaltySDK } from "@src/client/sdk/loyalty";
import { getLoyaltyInvitedStatus } from "@src/client/loyalty/getLoyaltyInvitedStatus";
import { findTierNumber } from "@src/client/loyalty/findTierNumber";
import { noticeError } from "@src/helpers/monitoring";

export const setupCustomerLoyaltyDataEvent = async () => {
  let consentStatus = null,
    currentTierId = null,
    tierNumber = null,
    country = null,
    tiers = undefined;

  const {
    customer: { isAuthenticated }
  } = await sdkInstanceProvider("identity");

  if (await isAuthenticated()) {
    if (await getLoyaltyInvitedStatus()) {
      try {
        const loyaltySdk = await waitForLoyaltySDK();

        ({ consentStatus, country, currentTierId, tiers } =
          await loyaltySdk.getCustomerDetails());
        tierNumber = findTierNumber(currentTierId, tiers);
      } catch (error) {
        if (error.name !== "LoyaltyNotSupportedError") {
          noticeError(error);
        }
      }
    }
  }

  window[asosGlobalNamespace][siteChromeGlobalNamespace].pushToDataLayer({
    customerLoyaltyData: { consentStatus, currentTierId, tierNumber, country }
  });
};
